<template>
  <div class="panel__content__element">
    <div class="g-handle" />
    <accordion-element-component
      class="g-grey-box"
      v-bind="{Data: {icon: ['fas', 'bell'], title: $tc('messages.sharedTexts.alarms.alert', 0), subTitle: computedAlertsCountTitle}}"
      :disabled="computedDisabled"
      @set-page-message="setPageMessage"
    >
      <header-alerts-component :alarms="alarms" />
    </accordion-element-component>
  </div>
</template>

<script>
import AccordionElement from '@/components/elements/AccordionElement'
import HeaderAlerts from '@/components/HeaderAlerts'

export default
{
  name: 'AccordionAlerts',
  components:
  {
    'header-alerts-component': HeaderAlerts,
    'accordion-element-component': AccordionElement
  }, // Available in this.$options.name
  props: {
    alarms: {
      type: Object,
      default() {
        return {
          list: [{
            label: 'Moisture outside limits',
            urgency: 3,
            active: 1547568000000,
            passive: 'Jan 14th 2019',
            activeDT: 'Jan 15th 2019',
            passiveDT: null,
            state: 'red',
            handler: 'service-moist-alarm'
          }],
          count: 1,
          maximumUrgency: 3,
          maximumActiveUrgency: 3,
          maximumUrgencyState: 'red',
          maximumActiveUrgencyState: 'red'
        }
      }
    }
  },
  data() {
    return{
    }
  },
  computed: {
    computedAlarms() {
      if(this.alarms && this.alarms.list && this.alarms.list.length) {
        return this.alarms.list.filter(item => !item.fixed)
      }

      return []
    },
    computedDisabled() {
      return this.computedAlarms.length ? false : true
    },
    computedAlertsCountTitle() {
      let rtnStr = this.$t('messages.sharedTexts.alarms.loading')
      const plural = this.$tc('messages.sharedTexts.alarms.alert', (this.computedAlarms.length > 1) ? 0 : 1)

      if(this.computedAlarms && this.computedAlarms.length !== 0) {
        rtnStr = `${this.computedAlarms.length} ${plural}`
        
        if(this.computedActiveAlertsCount) {
          rtnStr += `<strong class="${this.alarms.maximumUrgencyState}">
            &nbsp;( ${this.computedActiveAlertsCount} )  ${this.$t('messages.sharedTexts.alarms.active')}
          </strong>
          `
        }
      } else {
        rtnStr = this.$t('messages.sharedTexts.alarms.noAlerts')
      }
      return rtnStr
    }, 
    computedActiveAlertsCount() {
      if(this.alarms && this.alarms.list) {
        const activeAlarms = this.computedAlarms.filter(alarm => isNaN(parseInt(alarm.passive, 10)) || alarm.active === alarm.passive)
        return activeAlarms.length
      } else {
        return 0
      }
    }
  },
  methods: {
    setPageMessage(message) {
      this.$emit('SetPageMessage', message)
    }
  }
}
</script>

<style lang="scss">
</style>
